import '../styles/NewsletterSection.css';

function NewsletterSection() {
  return (
    <section className="newsletter">
      <div className="newsletter__card">
        <div className="newsletter__content">
          <h2 className="newsletter__title">Subscribe to the Flare Newsletter</h2>
          <p className="newsletter__subtext">
            Join over 30,000 Flare community members. Sign up to the Flare newsletter today to
            hear the latest on product releases, ecosystem announcements and global events.
          </p>
          <a
            href="https://flare.network/sign-up"
            target="_blank"
            rel="noopener noreferrer"
            className="newsletter__cta"
          >
            Subscribe
          </a>
        </div>

        <img
          src={`${process.env.PUBLIC_URL}/images/newsletter-spheres.webp`}
          alt=""
          className="newsletter__image"
        />
      </div>
    </section>
  );
}

export default NewsletterSection;